import { render, staticRenderFns } from "./WorkerBalancePage.vue?vue&type=template&id=438787e7&"
import script from "./WorkerBalancePage.vue?vue&type=script&lang=js&"
export * from "./WorkerBalancePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports